export class WidgetError extends Error {
  constructor(
    message: string,
    public cause?: Error,
    public extraData: { [key: string]: string } = {},
  ) {
    super(message);
  }
}
